//node_modules
import React, { FunctionComponent } from "react";
import NextLink from "@adjust/website/src/components/NextLink";
import { Pagination } from "react-bootstrap";

//hooks
import usePaginationContext from "../hooks/usePaginationContext";

type PaginationItemProps = {
  index: number;
};

const PaginationItemComponent: FunctionComponent<PaginationItemProps> = ({ index }) => {
  const handler = usePaginationContext();

  if (handler.active(index)) {
    return <Pagination.Item active={true}>{index}</Pagination.Item>;
  }

  return (
    <NextLink href={handler.generatePath(index)}>
      <Pagination.Item>{index}</Pagination.Item>
    </NextLink>
  );
};

export default React.memo(PaginationItemComponent);
